import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Departamento, Empregador, Usuario } from '../../api.service';

@Component({
  selector: 'app-painel-dados-usuario',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './painel-dados-usuario.component.html'
})
export class PainelDadosUsuarioComponent {
  @Input({ required: true }) usuario!: Usuario;
  @Input() empregadores: Empregador[] = [];
  @Input() departamentos: Departamento[] = [];
  @Input() empregadorSelecionado = '';

  @Output() usuarioChange = new EventEmitter<Usuario>();
  @Output() empregadorSelecionadoChange = new EventEmitter<string>();

  emitirUsuario() {
    this.usuarioChange.emit(this.usuario);
  }

  alterarPerfil() {
    if (this.usuario.perfil === 'ADMIN_GLOBAL') {
      this.usuario.departamentoId = '';
      this.usuario.departamentoIds = [];
    }
    this.emitirUsuario();
  }

  alterarDepartamentos(ids: string[]) {
    this.usuario.departamentoIds = ids;
    this.usuario.departamentoId = ids[0] || '';
    this.emitirUsuario();
  }
}
